/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QuickAccessDashboardVisibility {
    None = 1,
    Own = 2,
}
